import {
  AssignUsersToCollectionQuery,
  AssignCollectionUsersData,
  CollectionUserEntry
} from './../../autogenerated/ZoomBridge';

export default class AssignUsersToCollection {
  /**
   * Don't confuse with ligtbox id and collection id.<br>
   * Internally, we are storing lightboxes as collection only. Both are same.
   * @param  {number} collectionId
   * @param  {string} commaSeparatedEmailIds
   */
  constructor(collectionId, commaSeparatedEmailIds) {
    /**
     * @type {Number}
     * @private
     */
    this.collectionId = collectionId;
    /**
     * @type {Array<CollectionUserEntry>}
     * @private
     */
    this.collectionUsers = commaSeparatedEmailIds ? commaSeparatedEmailIds.split(',').map(u => new CollectionUserEntry().setUserId(u)) : [];
  }
  /**
   * Executes the query. If assign user is successful, then returns true else throw error.
   * @returns {Promise.<Boolean,ErrorId>}
   */
  run() {
    const assignUsersToCollectionQuery = new AssignUsersToCollectionQuery();
    assignUsersToCollectionQuery.message = this.createMessage();
    return assignUsersToCollectionQuery.run();
  }


  /**
   * @private
   * @returns {AssignCollectionUsersData}
   */
  createMessage() {
    const assignCollectionUsersData = new AssignCollectionUsersData()
      .setCollectionId(this.collectionId)
      .setCollectionUsers(this.collectionUsers);
    return assignCollectionUsersData;
  }



}